const _ = "adyen-pe-popover", E = "adyen-pe-tooltip", A = `${_}-container`, O = `${_}__header`, t = `${_}__header-title`, o = `${_}__content`, n = `${E}__content`, S = `${_}__footer`;
export {
  _ as DEFAULT_POPOVER_CLASSNAME,
  E as DEFAULT_TOOLTIP_CLASSNAME,
  A as POPOVER_CONTAINER_CLASSNAME,
  o as POPOVER_CONTENT_CLASSNAME,
  S as POPOVER_FOOTER_CLASSNAME,
  O as POPOVER_HEADER_CLASSNAME,
  t as POPOVER_HEADER_TITLE_CLASSNAME,
  n as TOOLTIP_CONTENT_CLASSNAME
};
